module.exports = __webpack_public_path__ + "static/img/1.5872d06.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/1.png
// module id = 7Xa5
// module chunks = 0